export const GET_ORGANIZATION_REQUEST = '@app/GET_ORGANIZATION_REQUEST';
export const GET_ORGANIZATION_SUCCESS = '@app/GET_ORGANIZATION_SUCCESS';
export const GET_ORGANIZATION_FAILURE = '@app/GET_ORGANIZATION_FAILURE';
export const GET_ORGANIZATION_CANCEL = '@app/GET_ORGANIZATION_CANCEL';
export const RESET_ORGANIZATION = '@app/RESET_ORGANIZATION';
export const GET_ALL_ORGANIZATIONS_REQUEST = '@app/GET_ALL_ORGANIZATIONS_REQUEST';
export const GET_ALL_ORGANIZATIONS_SUCCESS = '@app/GET_ALL_ORGANIZATIONS_SUCCESS';
export const GET_ALL_ORGANIZATIONS_FAILURE = '@app/GET_ALL_ORGANIZATIONS_FAILURE';
export const GET_ALL_ORGANIZATIONS_CANCEL = '@app/GET_ALL_ORGANIZATIONS_CANCEL';
